import { create } from 'zustand'
import { getFavoritiIds, addFavorito, removeFavorito } from '../services/favoriti.service'
import { isAuthenticated } from '../services/api'

interface FavoritiState {
  favoritiIds: number[]
  loading: boolean

  // Azioni
  loadFavoriti: () => Promise<void>
  toggleFavorito: (localeId: number) => Promise<void>
  isFavorito: (localeId: number) => boolean
  clearFavoriti: () => void
}

export const useFavoritiStore = create<FavoritiState>((set, get) => ({
  favoritiIds: [],
  loading: false,

  loadFavoriti: async () => {
    if (!isAuthenticated()) {
      set({ favoritiIds: [] })
      return
    }
    set({ loading: true })
    try {
      const ids = await getFavoritiIds()
      set({ favoritiIds: ids, loading: false })
    } catch {
      set({ loading: false })
    }
  },

  toggleFavorito: async (localeId) => {
    if (!isAuthenticated()) {
      // Potremmo mostrare un messaggio per invitare al login
      return
    }

    const { favoritiIds } = get()
    const isFav = favoritiIds.includes(localeId)

    // Aggiornamento ottimistico
    if (isFav) {
      set({ favoritiIds: favoritiIds.filter(id => id !== localeId) })
      try {
        await removeFavorito(localeId)
      } catch {
        // Rollback
        set({ favoritiIds: [...favoritiIds] })
      }
    } else {
      set({ favoritiIds: [...favoritiIds, localeId] })
      try {
        await addFavorito(localeId)
      } catch {
        // Rollback
        set({ favoritiIds: favoritiIds.filter(id => id !== localeId) })
      }
    }
  },

  isFavorito: (localeId) => get().favoritiIds.includes(localeId),

  clearFavoriti: () => set({ favoritiIds: [] }),
}))
